import React from "react";
import MUIDialog from "@material-ui/core/Dialog";
import MaterialCircularProgress from "@material-ui/core/CircularProgress";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  paper: {
    background: "transparent",
    boxShadow: "none",
    overflow: "hidden",
  },
  progress: {
    color: "#444444",
  },
  scOnly: {
    position: "absolute",
    left: "-10000px",
    top: "auto",
    width: "1px",
    height: "1px",
    overflow: "hidden",
  },
}));

const Loading = () => {
  const classes = useStyles();
  const dialogContainerRef = React.useRef(null);

  const dialog = (
    <MUIDialog
      open
      classes={{
        paper: classes.paper,
      }}
      TransitionProps={{ role: "presentation" }}
      container={() => dialogContainerRef.current}
    >
      <div role="region" aria-describedby="loading-progress" aria-busy={true}>
        <MaterialCircularProgress
          className={classes.progress}
          disableShrink
          aria-labelledby="loading-progress"
        />
        <p className={classes.scOnly} id="loading-progress">Loading content, please wait...</p>
      </div>
    </MUIDialog>
  );

  return (
    <div ref={dialogContainerRef}>
      {dialog}
    </div>
  );
};

export default Loading;
 